export default {
  auth: {},
}
